import TagManager from 'react-gtm-module';

interface GTMConfig {
  gtmId: string;
}

/**
 * Inicializa Google Tag Manager
 * GTM se encargará de gestionar GA4 y otras herramientas de marketing
 */
export const initializeGTM = (gtmId: string) => {
  if (!gtmId) {
    console.warn('GTM ID no proporcionado');
    return;
  }

  const tagManagerArgs: GTMConfig = {
    gtmId,
  };

  TagManager.initialize(tagManagerArgs);
  console.log('Google Tag Manager inicializado con ID:', gtmId);
};

/**
 * Envía un evento de pageview a GTM
 * GTM lo enviará automáticamente a GA4 si está configurado
 */
export const trackPageView = (path: string, title?: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      page: path,
      title: title || document.title,
    },
  });
};

/**
 * Envía un evento personalizado a GTM
 * Ejemplo: trackEvent('button_click', { button_name: 'contact_form' })
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...eventParams,
    },
  });
};

/**
 * Envía datos personalizados al dataLayer de GTM
 * Para casos de uso avanzados
 */
export const pushToDataLayer = (data: Record<string, any>) => {
  TagManager.dataLayer({
    dataLayer: data,
  });
};
